import { useEffect, useState } from 'react'
import { usePhotoById } from '@/entities/Photos'
import { errorHandler } from '@/shared/lib/errorHandler'
import { usePhotoPolygonsOnlyByIdApi } from '../api/edit-photo-polygons-api'
import type { Polygon } from '../model/types'
import type { FormikConfig } from 'formik'

export const useEditPhotoWithPolygons = (
  selectedPhotoId: number,
  queryKeyForObjectUpdate: string,
  onCloseModal: () => void,
) => {
  const { data: currentPhoto, isLoading: isLoadingPhoto } = usePhotoById(selectedPhotoId)

  const [polygons, setPolygons] = useState<Polygon[]>([])

  const { mutateAsync, isPending: isPendingUpdate } = usePhotoPolygonsOnlyByIdApi(
    queryKeyForObjectUpdate,
    selectedPhotoId,
  )

  const submitFormPolygons: FormikConfig<Polygon[]>['onSubmit'] = async values => {
    try {
      await mutateAsync({
        id: selectedPhotoId,
        polygons: values,
      })
      onCloseModal()
    } catch (e) {
      errorHandler(e)
    }
  }

  useEffect(() => {
    const fromApi = currentPhoto?.polygons ?? []
    setPolygons(fromApi)
  }, [currentPhoto])

  return {
    currentPhoto,
    isLoadingPhoto,
    polygons,
    setPolygons,
    isPendingUpdate,
    submitFormPolygons,
  }
}
